<script setup>
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {User, Settings, CreditCard, LogOut} from 'lucide-vue-next';
import {Button} from "@/components/ui/button";
import {Avatar, AvatarFallback} from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const router = useRouter();
const userName = ref(localStorage.getItem('name') || 'User');
const isOpen = ref(false);

import Login from "@/pages/login.vue";
import state from "./store";

import {monitorToken} from "@/services/networkService.js";
import {validateToken} from "@/services/userService.js";

onMounted(() => {
  state.isLoggedIn = validateToken();

  if (state.isLoggedIn) {
    monitorToken();
  }
});

function goHome() {
  router.push({path: '/'});
}

const handleLogout = () => {
  localStorage.removeItem('name');
  localStorage.removeItem('email');
  localStorage.removeItem('token');
  localStorage.removeItem('expires');
  state.isLoggedIn = false;
  
  window.location.href = '/login';
};

const navigateTo = (path) => {
  router.push(path);
  isOpen.value = false;
};
</script>

<template>
  <div class="app">
    <nav v-if="state.isLoggedIn" class="bg-current p-6 bg-pink-600">
      <div class="container flex justify-between items-center">
        <h1 @click="goHome" class="text-3xl font-bold tracking-tight text-white cursor-pointer">PanelPop</h1>
        
        <DropdownMenu v-model:open="isOpen" v-if="state.isLoggedIn">
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" class="relative h-8 w-auto text-white">
              <User class="h-4 w-4" />
              {{ userName }}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent class="w-56" align="end">
            <div class="flex items-center justify-start gap-2 p-2">
              <div class="flex flex-col space-y-1 leading-none">
                <p class="font-medium">{{ userName }}</p>
              </div>
            </div>
            <DropdownMenuItem @click="navigateTo('/settings')">
              <Settings class="mr-2 h-4 w-4" />
              <span>Settings</span>
            </DropdownMenuItem>
            <DropdownMenuItem @click="navigateTo('/billing')">
              <CreditCard class="mr-2 h-4 w-4" />
              <span>Billing</span>
            </DropdownMenuItem>
            <DropdownMenuItem @click="handleLogout">
              <LogOut class="mr-2 h-4 w-4" />
              <span>Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
    <main v-if="state.isLoggedIn" class="p-8">
      <RouterView/>
    </main>
    <main v-else>
      <Login/>
    </main>
  </div>
</template>

<style scoped>
h1 {
  font-family: "Baloo Thambi 2", serif;
  font-optical-sizing: auto;
  font-size: 32px;
}
</style>
